(ns dre.components.tooltip
  (:require
   ["antd" :refer [Tooltip]]
   [dre.i18n.views :refer [tr]]))

(defn tooltip-wrapper
  ([title content]
   [tooltip-wrapper title content {}])
  ([title content props]
  (if title
    [:> Tooltip
     (merge {:title (if (string? title)
                     [tr title]
                      title)
             :mouseEnterDelay 0.5} props)
     content]
    content)))
